import type { PreparedAction } from "@shared/actions/action-doc-builder"
import type { Narrative } from "@shared/actions/create-narrative"

export interface Payload {
  titleForAnalytics: string | null | undefined
}

export default function USER_SIGN_ERROR(payload: Payload): PreparedAction {
  return {
    name: "USER_SIGN_ERROR",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative(findFn: Function, _userId: string): Narrative | null {
      return {
        titleForAnalytics: payload.titleForAnalytics,
      }
    },
  }
}
